module.exports = __webpack_public_path__ + "static/media/dogwood_compote.ad4055ff.png";